import PropTypes from 'prop-types';

import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';
import { getErrorMessage } from '#lib/errors/errorMessages';
import { useAcceptInvite, useDeclineInvite } from '#orgFeature/models/org/mutations';

const ROLE_LABELS = {
	owner: 'Eigentümer',
	admin: 'Admin',
	member: 'Mitglied',
};

export const PendingInvitesModal = ({ invites }) => {
	const acceptMutation = useAcceptInvite();
	const declineMutation = useDeclineInvite();

	const isPending = acceptMutation.isPending || declineMutation.isPending;

	return (
		<Modal isOpen={invites.length > 0} size="s" closeOnBackdrop={false}>
			<Panel.Header subtitle="Sie haben offene Einladungen. Bitte bearbeiten Sie diese, um fortzufahren.">
				Team-Einladungen
			</Panel.Header>

			{(acceptMutation.isError || declineMutation.isError) && (
				<div className="px-5 py-3 bg-red-50 border-b border-red-200 flex-shrink-0">
					<p className="text-sm text-warning-700">
						{getErrorMessage(acceptMutation.error ?? declineMutation.error)}
					</p>
				</div>
			)}

			<Panel.Body padded={false}>
				<div className="divide-y divide-bgBase-400">
					{invites.map((invite) => {
						const expiresAt = new Date(invite.expiresAt);
						const expiresLabel = expiresAt.toLocaleDateString('de-DE', {
							day: '2-digit',
							month: '2-digit',
							year: 'numeric',
						});

						return (
							<div key={invite.id} className="px-5 py-4">
								<div className="flex items-start justify-between gap-4">
									<div className="min-w-0">
										<p className="text-sm font-medium text-text truncate">
											{invite.orgName ?? 'Unbekannte Organisation'}
										</p>
										<p className="text-xs text-bgBase-800 mt-0.5">
											Rolle: {ROLE_LABELS[invite.role] ?? invite.role} &middot; Läuft ab:{' '}
											{expiresLabel}
										</p>
									</div>
									<div className="flex gap-2 flex-shrink-0">
										<button
											onClick={() => declineMutation.mutate(invite.id)}
											disabled={isPending}
											className="px-3 py-1.5 text-sm text-text border border-bgBase-400 hover:bg-bgBase-200 rounded-control transition-colors disabled:opacity-50"
										>
											Ablehnen
										</button>
										<button
											onClick={() => acceptMutation.mutate(invite.id)}
											disabled={isPending}
											className="px-3 py-1.5 text-sm text-white bg-primary-500 hover:bg-primary-600 rounded-control transition-colors disabled:opacity-50"
										>
											{acceptMutation.isPending ? '...' : 'Annehmen'}
										</button>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</Panel.Body>
		</Modal>
	);
};

PendingInvitesModal.propTypes = {
	invites: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			orgId: PropTypes.string.isRequired,
			orgName: PropTypes.string,
			role: PropTypes.string.isRequired,
			invitedAt: PropTypes.string,
			expiresAt: PropTypes.string.isRequired,
		}),
	).isRequired,
};
